import React from 'react';

import './Home.scss';

import { withRouter } from 'react-router-dom';

import asyncComponent from 'Demora/AsyncComponent';

import headerFooterHeight from 'Demora/headerFooterHeight';

import iosInnerHeight from 'ios-inner-height';

import { Helmet } from 'react-helmet';

import NewPlanCountdown from './NewPlanCountdown';

const LearnMore = asyncComponent(
	() => import(/* webpackChunkName: "LearnMore" */ './LearnMore')
);

const HomePagePlan = asyncComponent(
	() => import(/* webpackChunkName: "HomePagePlan" */ './HomePagePlan')
);

class HomePage extends React.Component {
	constructor(props, context) {
		super(props, context);

		let pg = new URLSearchParams(props.location.search).get('pg');

		if (typeof pg !== 'string') {
			pg = Math.floor(Math.random() * 4);
		}

		this.state = {
			hostname: document.location.hostname,
			learnMore: false,
			pg: parseInt(pg),
		};

		window._paq.push(['trackEvent', 'Home page view', 'View', 'View_' + pg]);
	}

	componentDidMount() {
		this.changeHeight();

		if (this.isClickBankHopLink()) {
			const spar = new URLSearchParams(this.props.location.search);

			document.location =
				'http://1.cashjuice.pay.clickbank.net?cjtid=' +
				spar.get('cjtid') +
				'&cjpid=' +
				spar.get('cjpid');

			return;
		}

		if (!this.isNewPlan()) {
			window.addEventListener('scroll', this.windowScroll);
		}
	}

	componentWillUnmount() {
		this.unmounted = true;
		this.removeEventListener();
	}

	removeEventListener = () => {
		window.removeEventListener('scroll', this.windowScroll);
	};

	windowScroll = () => {
		if (!this.state.learnMore) {
			this.learnMore();
			this.removeEventListener();
		}
	};

	changeHeight = () => {
		if (!document.getElementsByClassName('navbarTop')[0]) {
			setTimeout(this.changeHeight, 500);

			return;
		}

		const hf = headerFooterHeight();

		this.setState({
			height: iosInnerHeight() - hf.header - hf.footer + 14 + 14 + 1,
		});
	};

	learnMore = () => {
		let state = this.state;

		let hf = headerFooterHeight();

		if (!state.learnMore) {
			window._paq.push([
				'trackEvent',
				'Home page view',
				'Click on learn more',
				'Click_' + state.pg,
			]);
		}

		this.setState(
			{
				learnMore: true,
			},
			() => {
				setTimeout(() => {
					this.setState({
						height: window.innerHeight - hf.header - 2 + 5 + 17,
					});

					this.scrollToID('learnMore');
				}, 150);
			}
		);
	};

	scrollToID = (id) => {
		if (this.unmounted) {
			return;
		}
		let p = document.getElementById(id);

		if (!p) {
			return;
		}

		p = p.getBoundingClientRect();

		const scrollHeight = p.top - headerFooterHeight().header + 8 + 6 + 5;

		const startPos = window.scrollY;

		const moveBy = scrollHeight;

		const scrollDuration = Math.abs(moveBy / 2);

		const steps = parseInt(scrollDuration / 15) + 1;

		const scrollStep = Math.PI / steps,
			cosParameter = moveBy / 2;

		var scrollCount = 0,
			scrollMargin;

		var scrollInterval = setInterval(function () {
			if (steps > scrollCount) {
				scrollCount = scrollCount + 1;
				scrollMargin =
					cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);

				window.scrollTo(0, startPos + scrollMargin);
			}
		}, 15);
	};

	isNewPlan() {
		return this.state.hostname === '2-cj.com';
	}

	isClickBankHopLink() {
		const spar = new URLSearchParams(this.props.location.search);

		return spar.get('cjtid') && spar.get('cjpid');
	}

	render() {
		const state = this.state;

		const learnMore = state.learnMore;

		if (this.isClickBankHopLink()) {
			return null;
		}

		let text = (
			<div className='container text-center'>
				<div
					className='wrapper wow fadeInUp delay-05s animated'
					style={{ visibility: 'visible', animationName: 'fadeInUp' }}
				>
					<h2 className='top-title'>Socialize! Earn! Promote!</h2>
					<h2 className='top-title'>Attract More Followers, Build Your List</h2>
					<h3 className='title'>50,000+ Members</h3>
					<h4 className='sub-title'>Are Waiting For You</h4>
					<button
						type='submit'
						className='btn btn-warning btn-lg'
						onClick={this.learnMore}
					>
						Click Here To Learn More
					</button>
				</div>
			</div>
		);

		let style = {
			background: 'url(/assets/home/people_new1.jpg) no-repeat',
			backgroundSize: 'cover',
			backgroundColor: '#000048',
			backgroundPosition: 'center',
		};

		switch (state.pg) {
			case 1:
				text = (
					<div
						className='wrapper wow fadeInUp delay-05s animated mx-auto'
						style={{
							visibility: 'visible',
							animationName: 'fadeInUp',
							maxWidth: '1000px',
						}}
					>
						<h3 className='sub-title'>Earn...</h3>
						<h4 className='sub-title'>Promote...</h4>
						<h4 className='sub-title'>Socialize...</h4>
						<h2 className='top-title'>The FREE Way To...</h2>
						<h2 className='top-title'>
							Build Your Followers,
							<br />
							Build Your List,
							<br />
							Make Money!
						</h2>
						<h2 className='top-title'>And.... so much more</h2>
						<div className='text-center'>
							<button
								type='submit'
								className='btn btn-warning btn-lg'
								onClick={this.learnMore}
							>
								Click Here To Learn More
							</button>
						</div>
					</div>
				);

				style.background =
					'url(/assets/home/person_holding_bankn_hziKs.jpg) no-repeat';
				style.backgroundPosition = 'right';

				break;

			case 2:
				text = (
					<div
						className='wrapper wow fadeInUp delay-05s animated mx-auto'
						style={{
							visibility: 'visible',
							animationName: 'fadeInUp',
							maxWidth: '1000px',
						}}
					>
						<h3 className='sub-title'>Earn...</h3>
						<h4 className='sub-title'>Promote...</h4>
						<h4 className='sub-title'>Socialize...</h4>
						<h2 className='top-title'>The FREE Way To...</h2>
						<h2 className='top-title'>
							Build Your Followers,
							<br />
							Build Your List,
							<br />
							Make Money!
						</h2>
						<h2 className='top-title'>And.... so much more</h2>
						<div className='text-center'>
							<button
								type='submit'
								className='btn btn-warning btn-lg'
								onClick={this.learnMore}
							>
								Click Here To Learn More
							</button>
						</div>
					</div>
				);

				style.background =
					'url(/assets/home/close_up_of_human_ha_TFAab.jpg) no-repeat';
				style.backgroundPosition = 'center';

				break;
			case 3:
				text = (
					<div
						className='wrapper wow fadeInUp delay-05s animated text-center'
						style={{
							visibility: 'visible',
							animationName: 'fadeInUp',
							maxWidth: '800px',
						}}
					>
						<h3 className='sub-title op-bg'>
							Connect and learn from high “work at home” money makers
						</h3>
						<h3 className='sub-title'>It's FREE!</h3>
						<h2 className='top-title mb-4'>
							Build Your Followers,
							<br />
							Build Your List,
							<br />
							Make Money!
						</h2>
						<div>
							<button
								type='submit'
								className='btn btn-warning btn-lg'
								onClick={this.learnMore}
							>
								Click Here To Learn More
							</button>
						</div>
					</div>
				);

				style.background =
					'url(/assets/home/person_holding_bankn_hziKs.jpg) no-repeat';
				style.backgroundPosition = 'right';

				break;
		}

		const HPP = this.isNewPlan();

		const imageURL = 'https://cashjuice.com/assets/home/people_new1.jpg';

		const url = HPP ? 'https://2-cj.com' : 'https://cashjuice.com';

		const title = HPP
			? 'Start your online business today'
			: 'CashJuice - The Home of Network Marketers';

		const description = HPP
			? 'Get started today'
			: 'CashJuice is the home of money makers who make money "with" and "through" CashJuice. CashJuice has something for everyone. Beginners, intermediates and experts have a role to play in CashJuice.';

		return (
			<div className='new_homepage1'>
				<Helmet>
					<meta charSet='utf-8' />
					<title>{title}</title>
					<link rel='canonical' href={url} />

					<meta name='description' content={description} />

					<meta property='og:title' content={title} />
					<meta property='og:description' content={description} />
					<meta property='og:image' content={imageURL} />
					<meta property='og:url' content={url} />

					<meta name='twitter:title' content={title} />
					<meta name='twitter:description' content={description} />
					<meta name='twitter:image' content={imageURL} />
					<meta name='twitter:card' content='summary_large_image' />
				</Helmet>
				{!HPP && (
					<header className='main-header' id='header' style={style}>
						<div className='bg-color' style={{ minHeight: state.height }}>
							<NewPlanCountdown
								classNameInner='py-4 w-100'
								dontShowRegisterButton={true}
								dontShowLaunched={true}
							/>
							{text}
						</div>
					</header>
				)}
				{!HPP && learnMore && (
					<div className='learnMore' id='learnMore'>
						<LearnMore page={state.pg} />
					</div>
				)}
				{HPP && <HomePagePlan scrollToID={this.scrollToID} />}
			</div>
		);
	}
}

export default withRouter(HomePage);
